// removed by extract-text-webpack-plugin
module.exports = {"badgesList":"tutorialsSection-module_badgesList_3ECrZ","root":"tutorialsSection-module_root_331CU"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/tutorialsSection/tutorialsSection.module.css
// module id = 487
// module chunks = 1 3